
import httpService from './http.service';

class filesService {
    async listUsers() {
        return httpService.apiRequest('get', `user/list`);
    }
    async adminGetUserById(id) {
        return httpService.apiRequest('get', `user/'${id}`);
    }
    async adminUpdateUser(user) {
        return httpService.apiRequest('post', `user/'${user._id}`, user);
    }
    async getYears() {
        return httpService.apiRequest('get', `file/years`); 
    }
    async  listMonth(year) {
        return httpService.apiRequest('get', 'file/months/' + year);
    }
    async  listFolders(month,year) {
        return httpService.apiRequest('get', 'file/folders/' + month + '/' + year);
    }
    async  listFiles(folder,year) {
        return httpService.apiRequest('get', 'file/list/' + folder  + '/' + year );
    }

    async  deleteFiles(fileId) {
        return httpService.apiRequest('delete', 'file/delete/' + fileId);
    }
    async  saveAndGetUploadLinks(fileData) {
        return httpService.apiRequest('post', 'file/getUploadURL', fileData);
    }
    async uploadImageAmazon(presignedUrl, body) {
        return httpService.outsideRequest('put', presignedUrl, body);
    }
    async updateLocationAndDesc(folder) {
        return httpService.apiRequest('put', `file/folders/${folder._id}`, folder);
    }
    async getMapData(year,month) {
        return httpService.apiRequest('get', `file/mapData/${year}/${month}`);
    }
    async search(searchTerm) {
        return httpService.apiRequest('get', `file?search=${searchTerm}`);
    }

  
}

export default new filesService();



// WEBPACK FOOTER //
// ./src/services/file.service.js